// prettier-ignore
export const UPLOAD = "UPLOAD" as const
export const DOWNLOAD = "DOWNLOAD" as const
export const COMPRESS = "COMPRESS" as const
export const FETCH = "FETCH" as const
export const JSON_FILE = "JSON_FILE" as const
export const PLOT_PDF = "PLOT_PDF" as const
export const MERGE_PDF = "MERGE_PDF" as const
export const SPLIT_PDF = "SPLIT_PDF" as const
export const PARSE_PDF = "PARSE_PDF" as const
export const RASTERIZE_PDF = "RASTERIZE_PDF" as const
export const GENERATE_FILE = "GENERATE_FILE" as const